import ContactForm from "../../components/ContactForm";
import Seo from "../../components/Seo";

const ContactPage = () => {
    return (
        <>
            <Seo
                title="Contact"
                description="Contactez l'equipe PretUp : questions sur l'investissement, l'emprunt, l'inscription ou le fonctionnement de la plateforme."
            />
            <ContactForm />
        </>
    );
};

export default ContactPage;
